import clsx from "clsx";
import { Fragment } from "react";

export type MarketingCareersHeroProps = {
  /** Hero title. Wrap the emphasized phrase in `<em>` tags to render it in italic serif. */
  title: string;
  subtitle: string;
  className?: string;
};

function renderTitle(title: string) {
  return title.split(/<em>|<\/em>/).map((part, index) =>
    index % 2 === 1 ? (
      <span
        key={`${part}-${index}`}
        className="font-martina font-normal italic text-gail-primary"
      >
        {part}
      </span>
    ) : (
      <Fragment key={`${part}-${index}`}>{part}</Fragment>
    ),
  );
}

export function MarketingCareersHero({
  title,
  subtitle,
  className,
}: Readonly<MarketingCareersHeroProps>) {
  return (
    <section className={clsx("flex justify-center px-4 pt-16 pb-4", className)}>
      <div className="w-full max-w-6xl">
        <h1 className="max-w-4xl font-monument text-[2.25rem] leading-[1.15] tracking-tight text-black md:text-[2.75rem]">
          {renderTitle(title)}
        </h1>
        <p className="mt-4 max-w-md font-monument text-base leading-relaxed text-gail-gray md:text-lg">
          {subtitle}
        </p>
      </div>
    </section>
  );
}
